import {
    CHANGE_LOCALE,
    SET_SEARCH
} from '../actions';

export const setSearch = (data) => {
    return (
        {
            type: SET_SEARCH,
            payload: data
        }
    )
}

export const changeLocale = (locale) => {
    localStorage.setItem('currentLanguage', locale);
    return (
        {
            type: CHANGE_LOCALE,
            payload: locale
        }
    )
}

